import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const ContactUsFragment = Loadable(lazy(() => import('./view/ContactUsFragment')));

const contactUsRoutes = [
    { path: '/contact-us', element: <ContactUsFragment /> },
];

export default contactUsRoutes;
